import React, { useEffect, useState } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import CKEditor from "react-ckeditor-component";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const EditState = () => {
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [shortDescription, setShortDescription] = useState([]);
  const [formData, setFormData] = useState({
    state_name: "",
    state_code: "",
    image: "",
    latitude: "",
    longitude: "",
    map_url: "",
    short_description: "",
    description: "",
    status: "",
  });
  const [text, setText] = useState([]);
  const {
    AuthReducer: { auth }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const handleText = (e) => {
    const descriptions = e.editor.getData();
    setText(descriptions);
  }
  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "image") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleShortDescription = (e) => {
    const ShortDescription = e.editor.getData();
    setShortDescription(ShortDescription);
  }
  const handleSubmit = () => {
    const form = new FormData();
    form.append('state_name', formData.state_name);
    form.append('state_code', formData.state_code);
    form.append('image', formData.image);
    form.append('latitude', formData.latitude)
    form.append('longitude', formData.longitude)
    form.append('map_url', formData.map_url)
    // form.append('short_description', shortDescription)
    form.append('short_description', formData.short_description)
    form.append('description', text);
    form.append('status', formData.status);
    axios.put(`/api/admin/v1/update-state/${id}`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };

  useEffect(() => {
    axios(`/api/admin/v1/edit-state/${id}`, {
      headers: {
        Authorization: `Bearer ${auth?.token}`,
      },
    })
      .then((res) => {
        // console.log('res.data?.states?.short_description>>',res.data?.states);
        // setShortDescription(res.data?.states?.short_description);
        setText(res.data?.states?.description);
        setFormData({
          state_name: res.data?.states?.state_name,
          state_code: res.data?.states?.state_code,
          image: res.data?.states?.image,
          description: res.data?.states?.description,
          short_description: res.data?.states?.short_description,
          latitude: res.data?.states?.latitude,
          longitude: res.data?.states?.longitude,
          map_url: res.data?.states?.map_url,
          status: res.data?.states?.status,
        });
      })
      .catch((err) => console.log(err));
  }, [id, auth]);



  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Edit State</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-3 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>State Name <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.state_name)}
                value={formData?.state_name}
                name="state_name"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.state_name} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>State Code <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.state_code)}
                value={formData?.state_code}
                name="state_code"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.state_code} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Image</Label>
              <Input
                type="file"
                invalid={Boolean(errors?.image)}
                name="image"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.image}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Short Description <span className="text-danger fs-4">*</span></Label>
              <FormGroup>
                {/* <CKEditor content={shortDescription} events={{ "change": handleShortDescription }} /> */}
                <textarea name="short_description" className="form-control" rows="1" cols="110" onChange={inputHandler} value={formData?.short_description} />
              </FormGroup>
              <span className="d-block text-danger">{errors?.short_description}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Latitude <span className="text-danger fs-4">*</span></Label>
              <Input invalid={Boolean(errors?.latitude)} value={formData?.latitude} name="latitude" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.latitude} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Longitude <span className="text-danger fs-4">*</span></Label>
              <Input invalid={Boolean(errors?.longitude)} value={formData?.longitude} name="longitude" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.longitude} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Map Url <span className="text-danger fs-4">*</span></Label>
              <Input invalid={Boolean(errors?.map_url)} value={formData?.map_url} name="map_url" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.map_url} </span>
            </FormGroup>
          </div>

          <div className="col-md-9 offset-md-1">
            <FormGroup>
              <Label>Full Description</Label>
              <CKEditor content={text} events={{ "change": handleText }} />
              <span className="d-block text-danger"> {errors?.description} </span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-5">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditState;
